import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import styles from './style'
import { DOWNTILT_PREVIEW_DIMENSIONS } from 'helpers/globals'
import { cameraPropSelector } from 'selectors/components'

const mapStateToProps = state => ({
  distance: cameraPropSelector('distance')(state),
  sceneHeight: cameraPropSelector('sceneHeight')(state)
})

class CameraHeightLabel extends React.Component {
  render() {
    const { props: { distance, distanceDisplay, classes, sceneHeightLabelPxHeight,
      cameraHeightGreaterThanComputed, unit, sceneHeight } } = this
    return (
      <div
        className={classes.distanceToSubjectLabelContainer}
        style={{ width: `${(distance / distanceDisplay) * DOWNTILT_PREVIEW_DIMENSIONS.width}px` }}
      >
        <div className={classes.dividerLine} />
        <div
          className={classes.distanceToSubjectLabel}
          style={{ left: 'calc(50% - 10px)' }}
        >
          {`${Math.round(distance)}${unit}`}
        </div>
        <span className={classes.distanceToSubjectMarker}>
          <img src='https://maps.google.com/mapfiles/ms/micons/man.png' />
        </span>
        <div
          className={classes.sceneHeightLabelContainer}
          style={{
            height: sceneHeightLabelPxHeight,
            top: -sceneHeightLabelPxHeight + (cameraHeightGreaterThanComputed ? 5 : 0)
          }}
        >
          <div
            className={classes.sceneHeightLabel}
            style={{ bottom: 'calc(50% - 10px)' }}
          >
            {`${Math.round(sceneHeight)}${unit}`}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(
  injectSheet(styles)(CameraHeightLabel)
)



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/SceneHeightLabel/index.js